// import { App } from 'vue';

import { createPinia } from 'pinia';

const store = createPinia();

// 自动导入并注册模块
// const modulesFiles = import.meta.glob('./modules/**/*.js');

// for (const path in modulesFiles) {
//     modulesFiles[path]().then((module) => {
//         const moduleName = path.replace(/^\.\/modules\/(.*)\.\w+$/, '$1');
//         console.log(moduleName, module.default || module);
//         console.log(store.setupStore)
//         store.setupStore(moduleName, module.default || module);
//     });
// }

// // console.log(modulesFiles)

export function setupStore(app) {
    app.use(store);
}

export { store };


